<template>
  <div>
    <table class="table-auto w-full">
      <thead>
      <tr class="text-left border-b font-semibold">
        <td class="px-4 py-2">Title</td>
        <td class="px-4 py-2">Name</td>
        <td class="px-4 py-2">Initial value</td>
        <td class="px-4 py-2">Current Value</td>
        <td class="px-4 py-2"></td>
      </tr>
      </thead>
      <tbody>
      <tr class="border-b hover:bg-gray-200" v-for="option in options" :key="option.name">
        <td class="px-4 py-2">{{ option.title }}</td>
        <td class="px-4 py-2">{{ option.name }}</td>
        <td class="px-4 py-2">{{ option.default_value }}</td>
        <td class="px-4 py-2">
          <input type="text" @change="updateConfig(option)" v-model="option.current_value" class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                 placeholder="Current value"/>
        </td>
        <td class="px-4 py-2"></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SplashPageService from "../../services/splashPage.service";

export default {
  name: "PageConfigurations",
  props: {
    options: Array
  },
  methods: {
    updateConfig: function (option) {
      if (!this.$store.getters.can('edit_splash_pages'))
        this.$root.$emit("alert_error", ['Not allowed to edit page configurations']);
      SplashPageService.updateConfig(option.id, {
        custom_value: option.current_value
      }).then(response => {
        if (response.option != null) {
          this.$root.$emit("alert_success", [response.message]);
          this.$root.$emit("refresh_page", true);
        } else
          this.$root.$emit("alert_error", [response.message]);
      })
    }
  }
}
</script>

<style scoped>

</style>